import { Button, Stack } from "@mui/material";
import { X } from "react-feather";
import LogChat from "./LogChat";

export default function LogChatDetail({
    id,
    onClose,
}: {
    id: number,
    onClose?: () => void,
}) {
    return <Stack
            sx={{
                padding: 2,
                flexGrow: 1,
            }}
        >
            <Stack
                direction='row'
                sx={{
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
            >
                <h2>LogChat Detail</h2>
                <Button
                     onClick={() => {
                        if (onClose) { onClose() }
                    }}
                >
                    <X />
                </Button>
            </Stack>
            <Stack
                sx={{
                    flexGrow: 1,
                }}
            >

                <div>ID: {id}</div>
                {id > -1 && <LogChat id={id} />}
            </Stack>
        </Stack>
        
}
